module.exports = __webpack_public_path__ + "img/market_DFbg.facce1ec.png";